/** What the top-level loader is doing */
export enum LoadState {
  Idle    = -1,  // nothing happening
  InitialLoad = 1,   // first page
  SwitchingViews = 2, // changing filters / views
  ApplyingFilters = 3 //Applying filters
}
